import { render, staticRenderFns } from "./ScoreRadar.vue?vue&type=template&id=39dbd409&scoped=true"
import script from "./ScoreRadar.vue?vue&type=script&lang=js"
export * from "./ScoreRadar.vue?vue&type=script&lang=js"
import style0 from "./ScoreRadar.vue?vue&type=style&index=0&id=39dbd409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dbd409",
  null
  
)

export default component.exports